export const EMBEDDING_MODELS = {
	jina: { id: 'jina', label: 'Jina v4', vendor: 'Jina AI', model: 'jina-embeddings-v4' },
	scw: { id: 'scw', label: 'BGE Multilingual Gemma2', vendor: 'BAAI', model: 'bge-multilingual-gemma2' }
	// ionos: { id: 'ionos', label: 'bge-m3', vendor: 'BAAI' },
	// openai: { id: 'openai', label: 'text-embedding-3-large', vendor: 'OpenAI' }
	// anthropic: { id: 'anthropic', label: 'voyage-3.5' }
};

export type EmbeddingsVendor = keyof typeof EMBEDDING_MODELS;
